import { useState } from "react";
import { Modal, TextField, Button, CircularProgress } from "@mui/material";
import axios from "../customAxios.js";
import { useNavigate } from "react-router-dom";

const PickUpModal = ({ open, closeModal }) => {
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState(false);

  let navigate = useNavigate();

  const onClose = () => {
    handleClear();
    closeModal();
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError(false);
    try {
      const { data } = await axios.get(
        `/verify_pick_up_reception/${inputValue}/`
      );
      setSummary(`Destinatario: ${data.recipient} - Reference id: ${data.id}`);
    } catch (error) {
      setSummary("Error al validar el código de barras");
      setError(true);
      console.error(
        `Fallo al verificar la recepción: ${error?.response || error}`
      );
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const response = await axios.put(
        `/complete_pick_up_reception/${inputValue}/`,
        null
      );
      navigate(0);
    } catch (error) {
      setSummary("Error al confirmar la recepción del paquete");
      setError(true);
      console.error(
        `Fallo al confirmar la recepción: ${error?.response || error}`
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setInputValue("");
    setSummary(null);
    setError(false);
    setLoading(false);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "20px",
        }}
      >
        {summary ? (
          <h5>{summary}</h5>
        ) : (
          <>
            <h5>Inserte el Código de Barras del paquete recibido</h5>
            <TextField
              label="Código de Barras"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              fullWidth
              variant="outlined"
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "20px",
              }}
            >
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={loading}
              >
                Enviar
              </Button>
              {loading && (
                <CircularProgress size={40} className="loading-btn" />
              )}
            </div>
          </>
        )}
        <br />

        {summary && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button variant="outlined" onClick={handleClear} disabled={loading}>
              Atrás
            </Button>
            {!error && (
              <>
                <Button
                  variant="contained"
                  onClick={handleConfirm}
                  disabled={loading}
                  style={{ marginLeft: "30px" }}
                >
                  Confirmar
                </Button>

                {loading && (
                  <CircularProgress size={40} className="loading-btn" />
                )}
              </>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default PickUpModal;
